module.exports = __webpack_public_path__ + "img/shehuifuwu_02.61a93069.jpg";